import { exceptionKeys } from '../../lang/messages/exceptionMessages';
export type ExceptionKey = (typeof exceptionKeys)[number];
export interface ViolazioneInterface {
    propertyPath: string;
    code: ExceptionKey;
    message: string;
}

interface ExceptionInterface {
    type: string;
    content: ViolazioneInterface[];
}

type ResponseType =
    | 'VIOLATION'
    | 'EXCEPTION'
    | 'PERMISSION_DENIED'
    | 'SYSTEM_ERROR'
    | undefined;

export class Exception {
    content: ViolazioneInterface[];
    status: number;
    type: ResponseType;

    constructor(
        { type, content }: ExceptionInterface,
        status: number,
        digestError?: (content: any) => ViolazioneInterface[],
    ) {
        this.status = status;
        switch (status) {
            case 401:
                {
                    if (digestError) {
                        this.content = digestError(content);
                    } else {
                        this.content = [
                            {
                                code: 'exception.unauthorized',
                                message: 'Questa azione non è consentita',
                                propertyPath: '',
                            },
                        ];
                    }

                    this.type = 'PERMISSION_DENIED';
                }
                break;
            case 403:
                {
                    this.content = [
                        {
                            code: 'exception.unauthorized',
                            message: 'Questa azione non è consentita',
                            propertyPath: '',
                        },
                    ];
                    this.type = 'PERMISSION_DENIED';
                }
                break;
            case 404:
                {
                    this.content = [
                        {
                            code: 'exception.notFound',
                            message: 'Non trovato',
                            propertyPath: '',
                        },
                    ];
                    this.type = 'PERMISSION_DENIED';
                }
                break;
            case 500:
                {
                    this.content = [
                        {
                            code: 'exception.systemError',
                            message: 'Errore di sistema',
                            propertyPath: '',
                        },
                    ];
                    this.type = 'SYSTEM_ERROR';
                }
                break;
            default: {
                if (digestError) {
                    this.content = digestError(content);
                } else {
                    this.content = content;
                }
            }
        }
    }

    static fromResponse(
        response: any,
        digestError?: (content: any) => ViolazioneInterface[],
    ) {
        return new Exception(response.data, response.status, digestError);
    }

    getErroriForm(): { [key: string]: ExceptionKey } {
        const formViolations: { [key: string]: ExceptionKey } = {};
        this.content.forEach((violation) => {
            formViolations[violation.propertyPath] = violation.code;
        });
        return formViolations;
    }

    getViolazioni() {
        return this.content.map((violazione) => violazione.code);
    }

    setNotFound(code: ExceptionKey) {
        this.content = [
            {
                code: code,
                message: 'Non trovato',
                propertyPath: '',
            },
        ];
    }

    findByPropertyPath(propertyPath: string): ViolazioneInterface[] {
        return this.content.filter(
            (violation) => violation.propertyPath === propertyPath,
        );
    }

    getViolazioniByPropertyPath(propertyPath: string): string[] {
        return this.findByPropertyPath(propertyPath).map(
            (violazione) => violazione.code,
        );
    }
}
